import React, { useCallback } from 'react';
import { connect } from "react-redux";
import PropTypes from "prop-types";
import FeatureName from "../../../../../../visComponents/featureName";
import FeatureThumbnail from "../../../../../../visComponents/featureThumbnail";
import { featureInterface } from "../../../../../../../interfaces/featureInterface";
import config from "../../../../canvas/store/sqftConfig";
import { injectIntl } from "react-intl";
import {
  setSQFTActiveSubMenuButton,
  setSQFTMenuOpened,
  setSQFTSystemMessage
} from "../../../../../../../actions/sqftMenuFunctions";
import {activateEdgeTool} from "../../../../canvas/core/controls/canvasBridge";
import {getStringFeatureName} from "../../../../../../../misc/helpers";
import {hardCodeIsDeStefano} from "../../../../../../../misc/fabricatorHardcode";
import {isMiterEdge, isWaterfallFeature} from "../../../../../helpers/featureHelper";
import {MiteredEdgeHelpContent, WaterfallEdgeHelpContent} from "../../../../popup/systemMessage/EdgeHelpDiagrams";
import SpecialEdgeHelpContent from "../../../../popup/systemMessage/SpecialEdgeHelpContent";
import workspace from "../../../../canvas/core/workspace";
import {RESOURCE_ATTACHED_TO_TYPE} from "../../../../../constants";
import {changeCartFeature} from "../../../../../../../actions/actionFunctions";
import {prepareSQFTDataCore} from "../../../../canvas/core/workspace/workspaceDataMapper";
import {saveSQFTDataToQuote} from "../../../../../helpers/sqftQuotesHelper";
import {setWizardSelectedValues} from "../../../../../../../actions/wizardFunctions";
import sqftShapeManager from "../../../../canvas/store/sqftShapeManager";
import UniversalCanvasManager from "../../../../canvas/core/controls/UniversalCanvasManager";
import {setNextDisabledForCurrentStepModalFix} from "../../../../../../../actions/sqftModalFunctions";

const SqftNavEdgesFeature = (props) => {
  const {navItem, setSQFTSystemMessage, intl, fabricatorData, selectedEdge, setSelectedEdge,
    setSQFTActiveSubMenuButton, isModalFixOpen, modalFixFeatureId,
    changeCartFeature, cartItems, wizardIsActive, setWizardSelectedValues,
    wizardActiveItem, wizardList, setNextDisabledForCurrentStepModalFix } = props;

  // Extract properties from navItem
  const edgeFeature = navItem.part;
  const newWizardGroupId = navItem.fromWizardGroupId;
  const newWizardId = navItem.fromWizardId;
  const newWizardStep = navItem.newWizardStep;
  const newWizardGroup = navItem.newWizardGroup;

  const edgeClick = useCallback(async (e, disallowDemo) => {
    e.preventDefault();
    const targetWizardItem = wizardList.find(wizardItem => wizardItem.id === newWizardId) || wizardActiveItem;

    // 1. Update wizard selected value
    if (wizardIsActive && wizardActiveItem
      && newWizardStep !== null && newWizardStep !== undefined
      && newWizardGroup) {
      setWizardSelectedValues({
        [newWizardStep]: {
          wizardGroup: newWizardGroup,
          selectedFeature: edgeFeature,
          partId: edgeFeature.partId,
        }
      }, false, targetWizardItem);
    }

    // CONFLICT LOGIC
    if (isModalFixOpen) {
      // Update shapeFeatureId on canvas
      const edges = workspace.getAttachedToLineResource(RESOURCE_ATTACHED_TO_TYPE.edge);
      for (const edge of edges) {
        // sqftShapeManager.setShapeFeature(edge.id, edgeFeature);
        // sqftShapeManager.updateShapesWizardProperties();
        // edge.fromWizardGroupId = newWizardGroupId;
        // edge.fromWizardStep = newWizardStep;
        const line = workspace.getLineById(edge.attachedToId);
        const target = edge.part === 'line' ? line : null;
        const targetCorner = edge.part === 'lineCorner' ? line : null;
        const settings = {
          fromWizardGroupId: newWizardGroupId,
          fromWizardId: newWizardId,
          fromWizardStep: newWizardStep,
          disallowDemo: false
        };
        UniversalCanvasManager.applyEdgeTool(target, targetCorner, edgeFeature, settings);
        sqftShapeManager.updateShapesWizardProperties();
      }

      // Update cartItems
      const incompatibleCartItems = cartItems.filter(cartItem => cartItem.cartFeature.dbFeature.id === modalFixFeatureId);

      incompatibleCartItems.forEach(incompatibleCartItem => {
        changeCartFeature(Object.assign({}, incompatibleCartItem, {
          cartFeature: edgeFeature,
          fromWizardId: newWizardId || wizardActiveItem.id,
          fromWizardStep: newWizardStep,
          fromWizardGroupId: newWizardGroupId,
        }));
      });
      setNextDisabledForCurrentStepModalFix(false);

      // Save sqftData with new edge
      const coreData = prepareSQFTDataCore();
      // This will trigger rebuiltQuotesList
      await saveSQFTDataToQuote(coreData);

      // window.setTimeout(() => {
      //   updateQuoteSqftFeatureIds(incompatibleCartItems);
      // }, 1);
    } else {
      setSelectedEdge(edgeFeature.dbFeature.id);
      setSQFTActiveSubMenuButton(edgeFeature.dbFeature.id);
      activateEdgeTool(edgeFeature, newWizardGroupId, !!disallowDemo, newWizardId, newWizardStep);

      if (window.innerWidth < 991 && !config.tutorialIsRunning) {
        // Hide sidebar menu on mobile
        // Menu.hideSideBarContent();
      }
    }
  }, [edgeFeature, setSelectedEdge, setSQFTActiveSubMenuButton, newWizardGroupId, newWizardId, cartItems, changeCartFeature,
    isModalFixOpen, modalFixFeatureId, wizardIsActive, wizardActiveItem, wizardList, setWizardSelectedValues, newWizardGroup,
    newWizardStep, setNextDisabledForCurrentStepModalFix]);

  const isMiter = isMiterEdge(edgeFeature.dbFeature.id, edgeFeature);
  const isWaterfall = isWaterfallFeature(edgeFeature.dbFeature.id, edgeFeature);
  const hasSpecialHelp = isMiter || isWaterfall;

  const handleHelpClick = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    const edgeDescription = edgeFeature.dbFeature.description
      ? intl.formatMessage({id: edgeFeature.dbFeature.description})
      : null;

    if (isMiter) {
      setSQFTSystemMessage({
        isOpened: true,
        title: intl.formatMessage({ id: "sqft.navigation.edges.miteredHelp.title" }),
        content: (
          <SpecialEdgeHelpContent description={edgeDescription}>
            <MiteredEdgeHelpContent />
          </SpecialEdgeHelpContent>
        ),
        large: true
      });
      return;
    }

    if (isWaterfall) {
      setSQFTSystemMessage({
        isOpened: true,
        title: intl.formatMessage({ id: "sqft.navigation.edges.waterfallHelp.title" }),
        content: (
          <SpecialEdgeHelpContent description={edgeDescription}>
            <WaterfallEdgeHelpContent />
          </SpecialEdgeHelpContent>
        ),
        large: true
      });
      return;
    }

    setSQFTSystemMessage({
      isOpened: true,
      title: getStringFeatureName(edgeFeature, intl.messages, intl.locale, fabricatorData),
      content: intl.formatMessage({ id: edgeFeature.dbFeature.description }),
      large: false
    });
  }, [edgeFeature, setSQFTSystemMessage, intl, fabricatorData, isMiter, isWaterfall]);

  const isSelected = selectedEdge === edgeFeature.dbFeature.id;
  const featureName = getStringFeatureName(edgeFeature, intl.messages, intl.locale, fabricatorData);

  return (
    <li
      className={
        "lightbox-option-round lightbox-option-round--edge " +
        (isSelected ? "lightbox-option-selected" : "")
      }
      data-id={edgeFeature.dbFeature.id}
      data-shared-feature-name={featureName}
      onClick={edgeClick}
    >
      <div
        className={
          "lightbox-help-icon lightbox-help-icon-circle" +
          (hasSpecialHelp ? " lightbox-help-icon--info" : "")
        }
        onClick={handleHelpClick}
      />
      <div className="lightbox-option-round-loader-edge" />
      <div className={" " + (hardCodeIsDeStefano() ? ' lightbox-option-round--mh ' : '')}>
        <FeatureThumbnail feature={edgeFeature} />
      </div>
      <div className={
        "lightbox-description-text lightbox-description-text--edge" +
        (hardCodeIsDeStefano() ? ' lightbox-description-text--mh ' : '')
      }>
        <FeatureName feature={edgeFeature} maxLength={23} />
      </div>
    </li>
  );
};

SqftNavEdgesFeature.propTypes = {
  navItem: PropTypes.shape({
    part: PropTypes.shape(featureInterface).isRequired,
    fromWizardId: PropTypes.number,
    fromWizardGroupId: PropTypes.string,
    newWizardStep: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]),
    newWizardGroup: PropTypes.object,
  }).isRequired,
  setSQFTSystemMessage: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
  fabricatorData: PropTypes.object.isRequired,
  selectedEdge: PropTypes.number,
  setSelectedEdge: PropTypes.func.isRequired,
  setSQFTActiveSubMenuButton: PropTypes.func.isRequired,
  resourceState: PropTypes.object.isRequired,
  isModalFixOpen: PropTypes.bool,
  modalFixFeatureId: PropTypes.number,
  changeCartFeature: PropTypes.func.isRequired,
  cartItems: PropTypes.array,
  wizardIsActive: PropTypes.bool,
  wizardActiveItem: PropTypes.object,
  wizardList: PropTypes.array,
  setWizardSelectedValues: PropTypes.func.isRequired,
};

const mapStateToProps = (store) => ({
  fabricatorData: store.fabricatorState,
  resourceState: store.sqftResourceState || {},
  isModalFixOpen: store.sqftModalFixState.isModalFixOpen,
  modalFixFeatureId: store.sqftModalFixState.featureId,
  modalFixFeatureName: store.sqftModalFixState.featureName,
  cartItems: store.cartState.cartItems,
  wizardIsActive: store.wizardState.wizardIsActive,
  wizardActiveItem: store.wizardState.wizardActiveItem,
  wizardList: store.wizardState.wizardList,
});

const mapDispatchToProps = {
  setSQFTSystemMessage,
  setSQFTActiveSubMenuButton,
  setSQFTMenuOpened,
  changeCartFeature,
  setWizardSelectedValues,
  setNextDisabledForCurrentStepModalFix,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SqftNavEdgesFeature)
);
